import { DataGrid, type DataGridProps, type GridValidRowModel } from '@shared/components';

import { columns, type ExamCourseTimeExtension } from './column';

type BaseExamCourseTimeExtensionDataGridProps<TRowModel extends GridValidRowModel> = Omit<
  DataGridProps<TRowModel>,
  'columns'
>;

export default function ExamCourseTimeExtensionDataGrid(
  props: Readonly<BaseExamCourseTimeExtensionDataGridProps<ExamCourseTimeExtension>>,
) {
  return (
    <DataGrid
      {...props}
      disableColumnMenu
      hideFooter
      disableRowSelectionOnClick
      columns={columns}
      rowHeight={48}
      getRowClassName={(params) => (params.row.isDisabled ? 'row-disabled' : '')}
      sx={(theme) => ({
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.rounded(2),
        border: `1px solid ${theme.palette.grey[300]}`,
        boxShadow: 'none',
        '.MuiDataGrid-cell': {
          padding: theme.spacing(3),
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
          alignItems: 'flex-start',
        },
        '.MuiDataGrid-columnHeader': {
          padding: theme.spacing(3),
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
          backgroundColor: theme.palette.grey[100],
        },
        '& .row-disabled': {
          pointerEvents: 'none',
          color: theme.palette.grey[400],
        },
      })}
    />
  );
}
